// extracted by mini-css-extract-plugin
export default {"wrapper":"H4Vwc","content":"fZhNP","circle":"i2ioB","success":"qKHTY","error":"Hn5Dn","icon":"dkZyP","title":"d2jqV"};